module.exports = __webpack_public_path__ + "img/sjef_logo-white.0a01c067.png";